export default "__VITE_ASSET__xIpfyl2i__"